import React from 'react';
import { Outlet } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import PlacesProvider from '../contexts/PlacesContext';

/**
 * Wraps routes that need Google Maps APIs and places list state.
 */
const MapsPlacesLayout = () => (
	<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
		<PlacesProvider>
			<Outlet />
		</PlacesProvider>
	</APIProvider>
);

export default MapsPlacesLayout;
